import React, { useState } from 'react'
import { Box, Button, Divider, Typography } from '@mui/material'
import SingleMaterial from './SingleMaterial'

import { materialsStyles } from '../../../../styles/classes/MobilePreviewClasses'
import { useTranslation } from 'react-i18next'
import { inputTypeValueTransformer } from '../../../../utils/mobilePreview'
import { materialFields } from '../../../../lib/Constants'
import { itemPriceOptionsObj } from '../../../../utils/formBuilder'

const emptyItem = {
  name: '',
  description: '',
  quantity: '',
  id: '',
  price: '',
  tax: '',
  total_price: ''
}

const Materials = ({
  lineItemsList,
  onChangeValue,
  disabled,
  question,
  helpfulHint,
  isMandatory,
  isPreviewMode
}) => {
  let enableTotalAmount = question?.total_amount_due
  if (question?.item_price !== itemPriceOptionsObj.DISABLE_ITEM_PRICE_TAX_TOTAL_PRICE) {
    enableTotalAmount = false
  }
  const { t } = useTranslation()
  const { classes } = materialsStyles()
  const itemsLimit = question.items_limit ?? 1
  const [lineItems, setLineItems] = useState(
    lineItemsList ?? [{ ...emptyItem }]
  )

  const addLineItemHandler = () => {
    setLineItems(prevLineItems => {
      const newItems = [...prevLineItems, { ...emptyItem }]
      return newItems
    })
  }

  const removeLineItemHandler = index => {
    setLineItems(prevItems => {
      const newItems = [...prevItems]
      newItems.splice(index, 1)
      return newItems
    })
  }

  const calculateLineItemTotal = (lineItem) => {
    const amount = +lineItem?.price ?? 0
    const quantity = +lineItem?.quantity ?? 0
    const tax = +lineItem?.tax ?? 0

    const total = amount * quantity
    const totalWithTax = total + (total * tax) / 100

    return totalWithTax
  }

  const updateFieldsHandler = (index, field, value) => {
    setLineItems(prevItems => {
      let modValue = value
      const calculationCondition =
        field === materialFields.QUANTITY ||
        field === materialFields.PRICE ||
        field === materialFields.TAX
      if (field === materialFields.TAX && !!modValue && +modValue > 100) {
        modValue = '100'
      }
      if (calculationCondition) {
        modValue = inputTypeValueTransformer('numeric_only', modValue)
      }
      const newItems = [...prevItems]
      newItems[index][field] = modValue
      if (calculationCondition) {
        const calculatedTotal = calculateLineItemTotal(
          newItems[index]
        ).toString()
        newItems[index].total_price = calculatedTotal
      }
      return newItems
    })
  }

  const AddButton = () => {
    return (
      <Button
        className={classes.addButton}
        variant="outlined"
        size="small"
        onClick={addLineItemHandler}
        disabled={disabled}
      >
        + {t('mobile_preview.material.material')}
      </Button>
    )
  }

  const getSubtotal = () => {
    let subTotal = 0
    if (!lineItems) return (0).toFixed(2)
    for (const item of lineItems) {
      if (item.total_price) {
        subTotal += +item.total_price
      }
    }
    return subTotal?.toFixed(2)
  }

  const subTotalValue = getSubtotal()

  const DashedDivider = () => {
    // these styles do nor work as a class
    return <Box className={classes.dashedDividerContainer}>
        <hr className={classes.customDivider} />
      </Box>
  }

  const SubTotalComponent = () => {
    if (isPreviewMode) {
      return (
        <Box>
          <Typography className={classes.previewSubtotalValue}>
            $ {subTotalValue}
          </Typography>
          <Divider component="li" className={classes.divider} />
        </Box>
      )
    }
    const str = '-'
    return (
      <Box className={classes.subtotalContainer}>
        <Typography className={classes.subTotalValue}>
          {str.repeat(7)} {subTotalValue} {str.repeat(7)}
        </Typography>
        <Typography className={classes.subTotalLabel}>
          {t('subtotal')}
        </Typography>
      </Box>
    )
  }

  return (
    <Box className={[classes.container, isPreviewMode && classes.shadow]}>
      {isPreviewMode && <SubTotalComponent />}
      {lineItems?.map((item, index) => {
        return (
          <Box key={index}>
            <SingleMaterial
              updateCallback={() => {
                const newLineItems = JSON.parse(JSON.stringify(lineItems))
                onChangeValue(newLineItems)
              }}
              question={question}
              isMandatory={isMandatory}
              helpfulHint={helpfulHint}
              index={index}
              item={item}
              onChange={updateFieldsHandler}
              onRemove={removeLineItemHandler}
              disabled={disabled}
            />
            {index !== lineItems.length - 1 && <DashedDivider />}
          </Box>
        )
      })}
      {enableTotalAmount && !isPreviewMode && <SubTotalComponent />}
      <Box display="flex" justifyContent="center" paddingTop={'10px'}>
        {lineItems.length < itemsLimit && <AddButton />}
      </Box>
      <Divider component="li" className={classes.divider} />
    </Box>
  )
}

export default Materials
